import type { CallHeardMarker } from '@compass/client/types/call';

import type { HeardMap } from './useHeardFields';

/** Backend heard_markers map → in-memory HeardMap (skips unparseable timestamps). */
export function markersToHeardMap(markers?: Record<string, CallHeardMarker>): HeardMap {
  const out: HeardMap = {};
  if (!markers) return out;
  for (const [key, m] of Object.entries(markers)) {
    const at = m.heard_at ? Date.parse(m.heard_at) : NaN;
    if (Number.isNaN(at)) continue;
    // protojson serializes int64 as a JSON string — coerce so offsetMs is always a number.
    const offsetMs = m.heard_offset_ms != null ? Number(m.heard_offset_ms) : NaN;
    out[key] = Number.isFinite(offsetMs) ? { at, offsetMs } : { at };
  }
  return out;
}

/** In-memory HeardMap → backend heard_markers map (stamps marked_by when known). */
export function heardMapToMarkers(
  map: HeardMap,
  markedBy: string | undefined,
): Record<string, CallHeardMarker> {
  const out: Record<string, CallHeardMarker> = {};
  for (const [key, v] of Object.entries(map)) {
    const marker: CallHeardMarker = { heard_at: new Date(v.at).toISOString() };
    if (markedBy) marker.marked_by = markedBy;
    if (v.offsetMs != null) marker.heard_offset_ms = v.offsetMs;
    out[key] = marker;
  }
  return out;
}
